<template>
    <div>
        <div class="row py-2" v-for="tutorial in defaultTutorial" :key="tutorial.keyVideo">
            <div class="col-lg-5">
                <span></span>
                <!-- <img
                    :class="[`d-block w-100 cursor-pointer border-10`]"
                    height="230"
                    :src="`https://img.youtube.com/vi/${tutorial.keyVideo}/maxresdefault.jpg`"
                    alt="VIDEO"
                    @click="setModalVideoYouTube(tutorial)"
                > -->
                <iframe :src="tutorial.keyVideo" width="100%" height="230" :title="videoYoutube.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-7">
                <!-- <h3>{{tutorial.headerTitle}}</h3> -->
                <p v-html="tutorial.howto"></p>
                <b-button variant="outline-primary" @click="openTutorial(tutorial.action)">
                    <i class="fas fa-book"></i> ดูขั้นตอนอย่างละเอียด
                </b-button>
            </div>
        </div>
        <ModalVideoYouTube :videoYoutube="videoYoutube" />
    </div>
</template>

<script>
import { STEP_FIRST , STEP_SECOND } from '@/plugins/index'
import ModalVideoYouTube from '@/components/Modals/ModalVideoYouTube'

export default {
    props:{
        step: {
            type: String,
            default: ''
        }
    },
    components:{
        ModalVideoYouTube
    },
    data:() => ({
        videoYoutube:{
            show:false,
            title: "",
            key: ""
        }
    }),
    methods:{
        setModalVideoYouTube( video ){
            this.videoYoutube.title = video.headerTitle
            this.videoYoutube.key = video.keyVideo
            this.videoYoutube.show = true
        },
        openTutorial(action){
            return window.open(action, '_blank')
        }
    },
    computed:{
        defaultTutorial(){
            switch( this.step ){
                case STEP_FIRST:
                    return [
                        {
                            keyVideo: "https://drive.google.com/file/d/1Q87dEoiO8M14nfa4DPuvPErFPa2R1swI/preview",
                            // headerTitle: '1.1 เป็นเจ้าของบัญชี LINE OA',
                            howto: 'Messaging API ทำหน้าที่เป็นตัวกลางที่จะเชื่อมต่อ Server เข้ากับ LINE Official Account ทำให้สามารถเขียนโปรแกรมเพื่อสร้างบริการที่ผู้พัฒนาต้องการ ผ่านข้อความและโต้ตอบกับผู้ใช้ในลักษณะ Chatbot',
                            action: 'https://sharp-ermine-dd8.notion.site/LINE-Official-Account-LINE-OA-POPSHOP-30b5d36e06304e4d85a4e25fcf3b77d1'
                        },
                        // {
                        //     keyVideo: "trWN0RnG5JE",
                        //     headerTitle: '1.2 กรอก Channel ID และ Channel Secret',
                        //     howto: 'Channel ID และ Channel secret สามารถหาได้จากการเปิดใช้งาน Messaging API บน <a href="#">LINE Official Account</a> ในส่วนของ Webhook URL สามารถคัดลอก Link ด้านล่างไปวางและกดบันทึก',
                        //     action: ''
                        // },
                        // {
                        //     keyVideo: "trWN0RnG5JE",
                        //     headerTitle: '1.3 กรอก Channel Access Token',
                        //     howto: 'Channel Access Token สามารถหาได้จาก <a href="#">LINE Developers</a> ในหน้าตั้งค่า Messaging API ระบบจะสร้าง Channel access token จากนั้น ให้คัดลอกข้อมูลเพื่อนำมาใช้ตั้งค่า',
                        //     action: ''
                        // }
                    ]
                case STEP_SECOND:
                    return [
                        {
                            keyVideo: "https://drive.google.com/file/d/1tGsie2j_I2kxY-ad6qHdBAod8Ow4u1SK/preview",
                            // headerTitle: '2.1 สร้าง LINE Login Channel',
                            howto: 'LINE Login เป็นโซเชียลล็อกอินที่เอาไว้ทำ Authentication ให้ผู้ใช้กดปุ่มล็อกอินก็สามารถเข้าใช้งานเว็บไซต์หรือแอปของคุณด้วย LINE account โดยไม่ต้องมีการลงทะเบียนให้ยุ่งยาก',
                            action: 'https://sharp-ermine-dd8.notion.site/LINE-Official-Account-LINE-OA-POPSHOP-30b5d36e06304e4d85a4e25fcf3b77d1#e448d2cd12c744f697cd29387b6de336'
                        },
                        // {
                        //     keyVideo: "trWN0RnG5JE",
                        //     headerTitle: '2.2 กรอก Line Channel ID และ Channel Secret',
                        //     howto: 'คัดลอก Line Channel ID และ Channel Secret ที่ได้จาก LINE Developers นำมาวางด้านล่างและกดปุ่มเชื่อมต่อ Line OA',
                        //     action: ''
                        // }
                    ]
                default:
                    return []
            }
        }
    }
}
</script>